import { checklistAnnouncementsPreworkAndAgenda, completeDeck } from './SL00000Sprint00'
import { basicSlide, orderedListSlide, tPrework, tRecap, sprintDemosIntro, sprintDemos } from './SLSprint00'

import { retrospectiveBreakout, retrospectiveIntroduction } from './SLSprint00'
import { submissionPercentage } from './SLSprint00'
import { demoAssignment } from './SLSprint00'

import { holiday } from './SL20000Sprint01'
import { renderCalendar, renderFinalExamTimes } from './images/2025-08-fall/render-image'
import { tUnderConstruction } from './SL00000Sprint00'

import { list61200Sprint01 } from '../ActivityLists/AL61200Sprint01'

// Software Architecture (SA) module 1 / sprint 1 global values.
const sprint = 2
const activityList = () => { return list61200Sprint01(sprint) }

export const aa_2_1of1_PAaA = {
	'prework':[
		`All sprint ${sprint-1} activities and assignments due Sunday!`, '',
		`Be prepared for Sprint ${sprint-1} Demos and Retrospective`,
		`Be prepared for Sprint ${sprint} Planning, Discussion ${sprint}, and Lab` ],
	'announcements':[ 
		'Welcome back!', '',
		'Does everyone know where to find the recordings?',
		`Let’s stay focused on bringing closure to Sprint ${sprint-1} and completing Sprint ${sprint} Planning` ],
	'agenda':[
		`Sprint ${sprint-1} Demos and Retrospective`,
		`Sprint ${sprint} Planning`,
		`Sprint ${sprint} Planning Breakout`,
		`Discussion Board ${sprint} as a Scrum Team`,
		'Lab',
		'Prework for Next Class',
		'Recap' ]
}

const sprint2_class_1 = (activityList, xyz_2_1of1_PAaA, xyz_3_1of1Prework) => { 
	const metricsSubmissionPercentage = () => {
		return submissionPercentage([
			{ name: 'Discussion', due:19, submitted:18 },
			{ name: 'Quiz', due:19, submitted:19 },
			{ name: 'Lab', due:19, submitted:19 },
			{ name: 'Reflection', due:19, submitted:19}])
	}

		const retrospectiveInto = () => { return retrospectiveIntroduction(sprint)}
		const retrospective = () => {
			return orderedListSlide('Class Retrospective',
				'Feedback from Assignments & Reflections', [
				'Excellent job getting everything submitted on time... not 100% but really good.',
				'Thank you for your Reflection 4 comments',
				'Working with teams is challenging, can be enjoyable, and is essential',
				'... but mostly very challenging teammates, configuration management (Git, Azure, etc.), it’s hard',
				'Midterm and Friday off was a challenge' ])
		}

		const breakout = () =>{ return retrospectiveBreakout(sprint) }

	const sprintPlanning = () => {
		return orderedListSlide(`Sprint ${sprint} Planning`, `Sprint ${sprint} Expectations:`, [
			'Similar to other sprints with Discussion, Quiz, Lab, and Reflection',
			'We will complete our scrum team Discussion Board breakout session today',
			`We will have sprint ${sprint} Demos and Retrospective next Monday` ])
		
	}
	const activitiesReview = () => {
		return basicSlide('Activity List and Assignments Review', [
			'Let’s open our Blackboard shell and review the activity list and assignments together.' ]
		)
	}
	const shortBreak = () => {
		return basicSlide('Break', [
			'Let’s take a 5 minute break.' ])
	}
	const planningBreakout = () => {
		return orderedListSlide('Sprint Planning Scrum Team Breakout', 'As a scrum team:', [
			`Review Sprint ${sprint} activity list & assignments in detail`,
			'Discuss and identify questions/concerns',
			'Scrum master report out by sharing scrum team’s top 2 or 3 questions/concerns' ]
		)
	}
	const recap = () => { return tRecap(xyz_2_1of1_PAaA.agenda.slice(1))}

	const slideDeck = checklistAnnouncementsPreworkAndAgenda(xyz_2_1of1_PAaA, sprint, activityList)
	const preworkNext = () => { return tPrework('Prework For Next Class', xyz_3_1of1Prework, sprint, activityList) }
	return completeDeck(slideDeck, [ sprintDemosIntro, sprintDemos, demoAssignment, retrospectiveInto, 
		metricsSubmissionPercentage, retrospective, breakout, shortBreak, sprintPlanning, activitiesReview, 
		planningBreakout, preworkNext, recap])
}

const aa_2_1of1 = () => { return sprint2_class_1(activityList, aa_2_1of1_PAaA, aa_3_1of1_PAaA.prework) }

const aa_3_1of1_PAaA = {
	'prework':[
		'All sprint 1 activities and assignments due Sunday!', '',
		'Be prepared for Sprint 2 Planning, Discussion 2, and Lab' ],
	'announcements':[ 
		'TBD'],
	'agenda':[ 
		'TBD' ]
}
const aa_3_1of6 = () => { return [ tUnderConstruction, holiday, renderCalendar, renderFinalExamTimes ] }

export const aa_2_slidedeck = [ aa_2_1of1, aa_3_1of6, aa_3_1of6, aa_3_1of6, aa_3_1of6, aa_3_1of6 ] 